// Angular
import { isPlatformBrowser } from '@angular/common';
import { AfterViewInit, Component, PLATFORM_ID, inject, DestroyRef, ChangeDetectionStrategy } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
// Lodash
import { get } from 'lodash';
// Environments
import { environment } from '@environment';
import { LazyLoadScriptService } from '@core/utils';
// App Version
import packageInfo from '@packageInfo';

@Component({
  selector: 'app-zendesk-widget',
  changeDetection: ChangeDetectionStrategy.Eager,
  template: '',
})
export class ZendeskWidgetComponent implements AfterViewInit {
  private readonly lazyLoadScriptService = inject(LazyLoadScriptService);
  private readonly platformId = inject<Object>(PLATFORM_ID);
  private readonly destroyRef = inject(DestroyRef);

  /**
   * After HTML View Init
   * @memberof ZendeskWidgetComponent
   */
  ngAfterViewInit(): void {
    const isZendeskEnabled = get(
      environment,
      'zendesk.isZendeskEnabled',
      false,
    );
    if (isZendeskEnabled && isPlatformBrowser(this.platformId)) {
      try {
        const scriptUrl = get(environment, 'zendesk.scriptUrl', '');
        this.lazyLoadScriptService
          .loadScript(scriptUrl, 'ze-snippet')
          .pipe(takeUntilDestroyed(this.destroyRef))
          .subscribe(() => {
            const appName = packageInfo.name;
            const appVersion = packageInfo.version;
            (window as any).zESettings = {
              errorReporting: false,
              webWidget: {
                contactForm: {
                  tags: [`${appName}-v${appVersion}`],
                },
              },
            };
          });
      } catch (error) {
        console.log('Error while loading Zendesk widget script');
      }
    }
  }
}
